<dx-box width="100%" direction="row" *ngIf="showToolbar" class="paging-toolbar-container">
    <dxi-item [ratio]="1" *ngIf="pagingConfig?.visible">
        <dx-toolbar width="100%" class="paging-toolbar">
            <dxi-item location="before" *ngIf="pagingConfig?.showPageSizeSelector">
                <div *dxTemplate class="cc-page-size-selector">
                    <div class="dx-field-label">Rows / Page:</div>
                </div>
            </dxi-item>
            <dxi-item location="before" *ngIf="pagingConfig?.showPageSizeSelector">
                <div *dxTemplate class="cc-page-size-selector">
                    <div class="dx-field-value">
                        <dx-select-box
                            [value]="pageSize"
                            [items]="pagingConfig?.allowedPageSizes"
                            (onValueChanged)="onPageSizeChange($event)"
                        ></dx-select-box>
                    </div>
                </div>
            </dxi-item>
            <dxi-item location="before" *ngIf="pagingConfig?.showNavigationButtons && !isAllPageSize">
                <div *dxTemplate class="cc-page-navigators">
                    <dx-toolbar width="100%">
                        <dxi-item
                            [visible]="!isSmallScreen"
                            location="before"
                            widget="dxButton"
                            [options]="{
                                stylingMode: 'text',
                                icon: 'fas fa-fast-backward',
                                hint: 'First Page',
                                disabled: isFirstPage,
                                onClick: onFirstPage
                            }"
                        ></dxi-item>
                        <dxi-item
                            location="before"
                            widget="dxButton"
                            [options]="{
                                stylingMode: 'text',
                                icon: 'fas fa-step-backward',
                                hint: 'Previous Page',
                                disabled: isFirstPage || pageNumber === 0,
                                onClick: onPreviousPage
                            }"
                        ></dxi-item>
                        <dxi-item location="before">
                            <div *dxTemplate>
                                <dx-select-box
                                    [width]="64"
                                    [items]="pageNumbers"
                                    [value]="selectedPage"
                                    [searchEnabled]="true"
                                    (onValueChanged)="onPageChange($event)"
                                ></dx-select-box>
                            </div>
                        </dxi-item>
                        <dxi-item
                            location="before"
                            widget="dxButton"
                            [options]="{
                                stylingMode: 'text',
                                icon: 'fas fa-step-forward',
                                hint: 'Next Page',
                                disabled: isLastPage || pageNumber === noOfPages,
                                onClick: onNextPage
                            }"
                        ></dxi-item>
                        <dxi-item
                            [visible]="!isSmallScreen"
                            location="before"
                            widget="dxButton"
                            [options]="{
                                stylingMode: 'text',
                                icon: 'fas fa-fast-forward',
                                hint: 'Last Page',
                                disabled: isLastPage,
                                onClick: onLastPage
                            }"
                        ></dxi-item>
                    </dx-toolbar>
                </div>
            </dxi-item>
            <dxi-item location="before" *ngIf="pagingConfig?.showInfo" [visible]="!isSmallScreen">
                <div *dxTemplate class="cc-page-info">
                    {{ pageInfoText }}
                </div>
            </dxi-item>
        </dx-toolbar>
    </dxi-item>
    <dxi-item baseSize="auto" *ngIf="!isSmallScreen">
        <dx-toolbar #pagingToolbar width="100%"></dx-toolbar>
    </dxi-item>
</dx-box>
